// extracted by mini-css-extract-plugin
export default {"selectText":"CountryPicker_selectText__EVQO2","image":"CountryPicker_image__jLVj+","optionContainer":"CountryPicker_optionContainer__pHnaL"};